export default (params) => ({
  trigger: {
    name: 'help_after_purchase.go_to_support_hub',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'prominent_above_the_fold',
          'prominent_below_the_fold',
          'less_prominent',
          'regular',
        ],
      },
    },
    event: {
      name: 'select_item_support',
    },
    nonInt: false,
  },
});
